import moment, {Moment, MomentInput} from 'moment';

export const generateMomentDateRange = (start: MomentInput, end: MomentInput): Moment[] => {
  const startMoment = moment(start);
  const endMoment = moment(end);

  let range: [Moment] = [startMoment];
  let currentMoment = startMoment;

  while (endMoment.isAfter(currentMoment)) {
    currentMoment = currentMoment.clone().add(1, 'days');
    range.push(currentMoment);
  }

  return range;
};
